const OVERLAY_HOST_ID = 'bh-rich-text-overlays';
const SIDEBAR_STACK_Z_INDEX = '2147483647';

type OverlayParent = Document | ShadowRoot | HTMLElement;

function overlayHostInRoot(root: OverlayParent): HTMLElement {
  const existing =
    'getElementById' in root && typeof root.getElementById === 'function'
      ? root.getElementById(OVERLAY_HOST_ID)
      : root.querySelector(`#${OVERLAY_HOST_ID}`);
  if (existing) {
    styleOverlayHost(existing as HTMLElement);
    return existing as HTMLElement;
  }

  const host = document.createElement('div');
  host.id = OVERLAY_HOST_ID;
  root.appendChild(host);
  styleOverlayHost(host);
  return host;
}

function styleOverlayHost(host: HTMLElement) {
  host.style.position = 'fixed';
  host.style.inset = '0';
  host.style.zIndex = SIDEBAR_STACK_Z_INDEX;
  host.style.pointerEvents = 'none';
  host.style.overflow = 'visible';
}

function shadowOverlayParent(root: ShadowRoot): OverlayParent {
  const sidebarOuter =
    (root.getElementById && root.getElementById('sidebarOuter')) ||
    root.querySelector('#sidebarOuter');
  if (sidebarOuter) return sidebarOuter as HTMLElement;

  const mount = window.BUGHERD_REACT_APP_SIDEBAR_MOUNT;
  if (mount && root.contains(mount)) return mount;

  return root;
}

export function getRichTextOverlayRoot(anchor?: Element | null): HTMLElement {
  if (typeof document === 'undefined') {
    return (anchor as HTMLElement) || (undefined as unknown as HTMLElement);
  }

  const node = anchor ?? document.body;
  const root = node.getRootNode();

  if (root instanceof ShadowRoot) {
    return overlayHostInRoot(shadowOverlayParent(root));
  }

  const antdContainer =
    (node instanceof Element && (node.closest('.antd-container') as HTMLElement | null)) ||
    (document.querySelector('.antd-container') as HTMLElement | null);
  if (antdContainer) return overlayHostInRoot(antdContainer);

  return overlayHostInRoot(document.body);
}
